export default __webpack_public_path__ + "static/media/avatar_169.80aecf73.png";